<template>
  <div class="documentList-msg">
    <div class="documentContent">
      <div class="inner">
        <div class="documentInner">
          <div class="screenTop">
            <p class="title">消息提醒</p>
            <div class="screenContent" v-show="tableData.length>0">
              <span class="name">消息内容</span>
              <el-input v-model="documentTitle" class="screenInput" placeholder="请输入"></el-input>
              <el-button type="warning" style="margin-left: 30px" class="button" @click="getDat(true)">搜索</el-button>
              <el-button class="button" @click="documentTitle = '';getDat(true);">重置</el-button>
            </div>
          </div>
          <div class="documentListContent" v-show="tableData.length>0">
            <el-table
              :data="tableData"
              class="lxrTable"
              style="width: 100%"
              :default-sort = "{prop: 'date', order: 'descending'}"
            >
              <el-table-column
                prop="content"
                label="消息内容">
              </el-table-column>
              <el-table-column
                prop="createTime"
                label="接收时间"
                sortable>
              </el-table-column>
            </el-table>
            <el-pagination
              @current-change="handleCurrentChange"
              :page-size="20"
              layout="prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
          <div class="documentListContent" v-show="tableData.length==0">
            <div class="empty">暂无数据</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
  export default {
    data() {
      return {
        documentTitle: '',
        total: 0,
        tableData: [],
        nowPage:0
      }
    },
    created(){
      this.getDat(false)
    },
    methods: {
      handleCurrentChange(n){
        this.nowPage = n-1;
        this.getDat(false)
      },
      getDat(b){
        let _this = this;
        if(b){
          _this.nowPage =0;
        }
        let obj = {
          form_data: {
            "content":_this.documentTitle
          },
          page_data:{
            current_page:_this.nowPage
          }
        };
        _this.ajpost('/api/system/findMessageList',obj,function (data) {
          _this.tableData = data.data.list
          _this.total = data.data.total
        })
      }
    }
  }
</script>
<style>
  @import "../../assets/less/msg.css";
</style>



// WEBPACK FOOTER //
// src/components/userCenter/msg.vue